import { GetStaticPaths, GetStaticProps } from "next";
import { ComponentProps } from "react";
import { makeContentHtml } from "@/components/Article/Content/makeContentHtml";
import { extractTableOfContent } from "@/components/TableOfContent/extractTableOfContent";
import { Slug } from "@/components/news/slug/Slug";
import { buildClient } from "@/lib/contentful/client";
import { NewsFields } from "@/lib/contentful/contentModel/news";
import { buildPreviewClient } from "@/lib/contentful/previewClient";

export const getStaticPaths: GetStaticPaths = async () => {
  const client = buildClient();
  const { items } = await client.getEntries<NewsFields>({
    content_type: "news",
    select: ["fields.slug"],
    order: ["-fields.date"],
    limit: 100,
  });

  const paths = items.map((item) => ({
    params: { slug: item.fields.slug },
  }));

  return {
    paths,
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps<ComponentProps<typeof Slug>> = async (context) => {
  const { params } = context;
  const client = buildClient();
  const previewClient = buildPreviewClient();

  if (typeof params?.slug !== "string") return { notFound: true };

  const { items } = await (context.preview ? previewClient : client).getEntries<NewsFields>({
    content_type: "news",
    "fields.slug": params.slug,
  });

  if (!items[0]) {
    return {
      notFound: true,
    };
  }

  const news = items[0];

  const tableOfContent = extractTableOfContent(news.fields.body);

  return {
    props: {
      news,
      tableOfContent,
      bodyHtml: makeContentHtml(news.fields.body),
    },
  };
};

export default Slug;
